import React from "react";
import { Table, Tag, Typography } from "antd";
import { formatValue, pretty, splitCreateAfter } from "utils/auditLogUtils";
import { CreateArraySection } from "./CreateArraySection";
import NoDataComponent from "components/Common/NoData";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

export type CreateRow = { field: string; value: any };

export const CreateChangesTable: React.FC<{ rows?: CreateRow[]; after?: any }> = ({ rows, after }) => {
  const { t } = useTranslation();
  // Prefer `after` if provided (so we can split arrays cleanly)
  const sourceAfter = after;
  let scalarRows: CreateRow[] = rows || [];
  let arraySections: Array<{ key: string; items: any[] }> = [];

  if (sourceAfter && typeof sourceAfter === "object") {
    const split = splitCreateAfter(sourceAfter);
    scalarRows = split.scalarRows;
    arraySections = split.arraySections;
  }



  const columns = [
    {
      title: t("Field"),
      dataIndex: "field",
      key: "field",
      render: (f: string) => <Text code>{t("auditLog." + f)}</Text>,
      width: "50%",
      ellipsis: true,
    },
    {
      title: t("Value"),
      dataIndex: "value",
      key: "value",
      render: (v: any) =>
        Array.isArray(v) ? (
          <span>{v.map((x, i) => <Tag color="processing" key={i}>{formatValue(x)}</Tag>)}</span>
        ) : (
          <Tag color="processing">{formatValue(v)}</Tag>
        ),
    },
  ];

  return (
    <div>
      {scalarRows?.length ? (
        <Table
          rowKey={(r) => r.field}
          dataSource={scalarRows}
          columns={columns}
          pagination={false}
          size="small"
        />
      ) : (
        <NoDataComponent />
      )}

      {/* Render a subtable for each array field */}
      {arraySections
        .filter((section) => section.items && section.items.length > 0)
        .map((section) => (
          <CreateArraySection key={section.key} title={section.key} items={section.items} />
        ))}
    </div>
  );
};
